import { apiClient } from './api.client';

export const jobsService = {
  recentVacancies,
  detailJob,
  detailVacancies,
  searcRecentVacancies,
  searchCompanies,
  searchApplicants,
  getCompanyById,
  getCompanySummaryById,
  ApplicantDetail,
  searchApplications,
  applyJob,
};

function recentVacancies() {
  return apiClient.get('/recent-vacancies/');
}

function applyJob(job) {
  return apiClient.post(`/api/user/candidate/apply-to-job/${job}/`, { job });
}

function searcRecentVacancies(filters) {
  return apiClient.get('/search-vacancies/', {
    params: filters,
  });
}

function _searcApplicants(filters) {
  return apiClient.get('/search-vacancies/', {
    params: filters,
  });
}

function searchApplications(filters) {
  return apiClient.get('/api/user/candidate/applications/', {
    params: filters,
  });
}

function searchApplicants(filters) {
  return apiClient.get('/search-applicants/', {
    params: filters,
  });
}

function searchCompanies(filters) {
  return apiClient.get('/search-company/', {
    params: filters,
  });
}

function getCompanyById(id) {
  return apiClient.get(`/company/${id}/`);
}

function getCompanySummaryById(id) {
  return apiClient.get(`/api/user/business/summary/${id}/`);
}

function detailJob(id) {
  return apiClient.get(`/api/cms/applicants/${id}/`);
}

function detailVacancies(id) {
  return apiClient.get(`/api/cms/jobposts/${id}/`);
}

function ApplicantDetail(id) {
  return apiClient.get(`/applicant/${id}/`);
}
